import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  card: {
    position: "absolute",
    minHeight: "80vh",
    maxWidth: "85vw",
    marginLeft: "auto",
    marginRight: "auto",
    padding: "0rem",
    marginTop: "4%",
    left: 0,
    right: 0,
    borderRadius: "1rem",
  },
  cardTitulo: {
    fontWeight: "bold",
  },
}));

export default useStyles;
